export enum ingredientsRoutesPaths {
  root = '/products/ingredients',
  general = '/products/ingredients/general',
  inventory = '/products/ingredients/inventory',
  advanced = '/products/ingredients/advanced',
}
